var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { cachedSet } from '../../../../utils/mobx/decorators/customComputed';
import { uniq } from '../../../../utils/helper/lodash_replacements';
export class ImportingTreeNode {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get entity() {
        return this.parent;
    }
    get allNodes() {
        const nodes = [];
        this.addRecursive(nodes);
        return uniq(nodes);
    }
    addRecursive(nodes) {
        if (!nodes.includes(this.entity)) {
            nodes.push(this.entity);
        }
        const directChildrenNotYetContained = this.ownChildren.filter(child => !nodes.includes(child));
        directChildrenNotYetContained.forEach(child => {
            if (child.importingTreeNode) {
                child.importingTreeNode.addRecursive(nodes);
            }
        });
    }
    get ownChildren() {
        const children = [];
        for (let i = 0; i < this.entity.exportingChildren.length; i++) {
            let child = this.entity.exportingChildren[i];
            if (typeof child === 'function') {
                child = child();
            }
            if (Array.isArray(child)) {
                children.push(...child);
            }
            else {
                children.push(child);
            }
        }
        return uniq(this.entity.exportingChildren.filter(c => !!c));
    }
}
__decorate([
    cachedSet
], ImportingTreeNode.prototype, "allNodes", null);
__decorate([
    cachedSet
], ImportingTreeNode.prototype, "ownChildren", null);
